import type { AxiosInstance } from 'axios';
import type { OsobySouhlasSeznamDto } from '../generated';

export const consentPreviewsQuery = async (
	axiosInstance: AxiosInstance
): Promise<OsobySouhlasSeznamDto> => {
	const { data } = await axiosInstance.get('/api/v1/souhlasy');
	return data;
};
